import { render } from "./Apps.vue?vue&type=template&id=91a8d72a&scoped=true"
import script from "./Apps.vue?vue&type=script&lang=js"
export * from "./Apps.vue?vue&type=script&lang=js"

import "./Apps.vue?vue&type=style&index=0&id=91a8d72a&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a8d72a"]])

export default __exports__